import { Component, OnInit } from '@angular/core';
import { DialogRef } from '@ngneat/dialog';

@Component({
  selector: 'app-modal-forbidden-subscription',
  templateUrl: './modal-forbidden-subscription.component.html',
  styleUrls: ['./modal-forbidden-subscription.component.scss']
})
export class ModalForbiddenSubscriptionComponent implements OnInit {
  constructor(public ref: DialogRef) { }

  ngOnInit() { }

  closeModal() {
    this.ref.close();
  }
}
